export class ComboBoxParams {
    id: string;
    name: string;
}
